var AnimationLoop   = require("enyo-anim/AnimationLoop"),
    DrawLoop        = require("enyo-ui/DrawLoop"),
    PerformanceMode = require("enyo-perf/PerformanceMode"),
    kind            = require("enyo/kind"),
    utils           = require("enyo/utils");

require("enyo-ui");

/**
 * [SliderDrawLoopSupport]{@link enyo-ui.SliderDrawLoopSupport} extends
 * enyo-ui.Slider to make use of enyo-ui.DrawLoop for asynchronous buffering of
 * slides.
 *
 * @mixin enyo-ui.SliderDrawLoopSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "enyo-ui.SliderDrawLoopSupport",

    /**
     * Counts dropped frames during time spent in performanceMode
     *
     * @type     {number}
     * @memberof enyo-ui.SliderDrawLoopSupport
     * @private
     */
    droppedFrames: 0,

    /**
     * @memberof enyo-ui.SliderDrawLoopSupport
     * @method
     * @private
     */
    constructed: kind.inherit(function(sup) {
        return function() {
            this.euid = this.euid || utils.uid();
            sup.apply(this, arguments);
            PerformanceMode.observe("on", this.bindSafely(this.performanceModeObserver));
        };
    }),

    /**
     * React to changes in performanceMode.
     *
     * @memberof enyo-ui.SliderDrawLoopSupport
     * @private
     */
    performanceModeObserver: function() {
        if (!PerformanceMode.on) {
            this.droppedFrames = 0;
            this.flushPerformanceModeQueue();
        }
    },

    /**
     * Defer bufferNext in PerformanceMode if framerate drops too low.
     *
     * @returns {bool} Whether to defer buffering the next slide.
     * @memberof enyo-ui.SliderDrawLoopSupport
     * @protected
     */
    shouldDeferBufferNextInPerformanceMode: function() {
        if (this.droppedFrames > 5) {
            return true;
        }
        else if (AnimationLoop.lastFrameDuration > (1000 / 60)) {
            this.droppedFrames++;

            return true;
        }
        else {
            return false;
        }
    },

    /**
     * Schedules bufferNext call to be executed asynchronously.
     *
     * @memberof enyo-ui.SliderDrawLoopSupport
     * @private
     */
    requestAsyncBufferNext: function() {
        DrawLoop.request(this.euid + "::bufferNext", this.bufferNext);
    },

    /**
     * Cancels the scheduled bufferNext call.
     *
     * @memberof enyo-ui.SliderDrawLoopSupport
     * @private
     */
    cancelAsyncBufferNext: function() {
        DrawLoop.cancel(this.euid + "::bufferNext");
    }

};
